import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-todo7",
  "use": "icon-icon-todo7-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-todo7\"><path d=\"M637.312 256a96 96 0 0 1 96 96v128a32 32 0 0 0 32 32h195.136a63.36 63.36 0 0 1 49.216 23.488 64.32 64.32 0 0 1-8.64 89.792l-428.416 357.76c-35.2 29.44-86.08 29.44-121.216 0L22.976 625.28A64.192 64.192 0 0 1 63.552 512h195.136a32 32 0 0 0 32-32v-128a96 96 0 0 1 96-96h250.624z m0 64H386.688a32 32 0 0 0-32 32v128l-0.448 9.216A96 96 0 0 1 258.688 576H64l428.416 357.952c11.392 9.536 27.776 9.536 39.168 0L960 576h-194.688a96 96 0 0 1-96-96v-128a32 32 0 0 0-32-32z m34.688-192a32 32 0 1 1 0 64h-320a32 32 0 0 1 0-64h320z m0-128a32 32 0 1 1 0 64h-320a32 32 0 0 1 0-64h320z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-todo7.svg
// module id = EYRg
// module chunks = 3